/* main file */

(function ($, app) {

  // Immediately (before anything goes)
  (function () {
  })();

  // When DOM is ready
    $(window).on('ready', function() {

  });

  // When everything is rendered
    $(window).on('load', function() {
      //  app.AutoHeight();
      //  app.setDimensions();
        app.SlickSliderSetup();
        app.AddClassScroll();
        app.m49();
      //  app.ArtistSlider();
    });

})(jQuery, app);